<template>
    <div class="doctorPage">
      <div class="centerHome">
        <div class="ccHomel">
          <div class="compentTable">
            <div class="info-card">
              <div class="date">{{ date }}</div>
              <div class="line"></div>
              <div class="title">{{ dataExportDetailsParams.hospName }}抽样报告(共{{ total }}份)</div>
            </div>
            <el-table 
              class="qcTable"
              ref="tableRef" 
              :data="list" 
              show-overflow-tooltip 
              v-loading="loading"
            >
              <el-table-column label="中心名称" prop="HospitalName" min-width="100"></el-table-column>
              <el-table-column label="抽样医生" prop="ModalityType" min-width='90'>
                <template slot-scope="scope">
                  <span v-if="scope.row.SubjectType == 2">{{scope.row.FirstApproverName}}</span>
                  <span v-if="scope.row.SubjectType == 3">{{scope.row.TechnictionName}}</span>
                  <span v-if="scope.row.SubjectType == 4">{{scope.row.ReportSubmitterName}}</span>
                </template>
              </el-table-column>
              <el-table-column label="报告编码" prop="AccNo" min-width='150'></el-table-column>
              <el-table-column label="设备类型" prop="ModalityType" min-width='90'></el-table-column>
              <el-table-column label="检查项目" prop="CheckingItems" min-width='150'></el-table-column>
              <el-table-column label="报告评分" prop="ReportScore" min-width='80'></el-table-column>
              <el-table-column label="影像评分" prop="ImageScore" min-width='80'></el-table-column>
              <el-table-column prop="TotalStatus" label="质控状态" column-key='TotalStatus' min-width="80">
                <template slot-scope="scope">
                  <span>{{scope.row.TotalStatus | forTotalStatus}}</span>
                </template>
              </el-table-column>
              <el-table-column label="专家名称" prop="QCPeoPleName" min-width='90'></el-table-column>
              <el-table-column label="完成时间" prop="QCDt" min-width='150'></el-table-column>
              <el-table-column label="操作" width="160">
                <template slot-scope="scope">
                  <span class="tableOpe" v-if="scope.row.TotalStatus<=123" @click="handleDetails(scope.row,'table')">查看详情</span>
                  <span class="tableOpe" 
                    v-else-if="scope.row.TotalStatus>123&&Array.isArray(scope.row.ExpertUserGuids) && scope.row.ExpertUserGuids.length<=1"
                    @click="handleDetails(scope.row,'length')"
                  >
                    查看结果
                  </span>
                  <!-- <span class="tableOpe" v-else @click="handleCurrentChange(scope.row,scope.$index,$event)">查看结果</span> -->
                </template>
              </el-table-column>
            </el-table>
            <div class="pages">
              <el-pagination 
                class="pageAll"
                layout="prev, pager, next"
                :total="total"
                :page-size='dataExportDetailsParams.pageSize'
                :current-page='dataExportDetailsParams.pageIndex' 
                @current-change='currentChange'
              />
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
  
<script>
import Api from '@/api'
import axios from '@/js/api'
import moment from 'moment'
export default {
  data() {
    return {
      loading: false,
      list: [],
      total: 0,
      date: '',
      datas: {},
    }
  },
  filters: {
    forTotalStatus: function (value) {
      return {
        '': '不限',
        '120': '已抽样',
        '123': '已分配',
        '125': '进行中',
        '130': '已完成',
        '140': '申诉中',
        '170': '已归档'
      } [value] || '不限';
    },
  },
  computed: {
    ...Vuex.mapState('dataExport', ['dataExportDetailsParams']),
    ...Vuex.mapState('managerPlanList', ['qcresultsList']),
  },
  activated() {
    this.date = moment(this.dataExportDetailsParams.dtMonth).format('YYYY年MM月')
    this.getDetails()
	},
  methods: {
    ...Vuex.mapMutations('breadcrumb', ['setqcresultsShow']),
    ...Vuex.mapMutations('doctor', ['setDetailsParameter']),
    ...Vuex.mapActions('managerPlanList', ['GetQCResultsByTask']),
    // 获取详情信息
    getDetails() {
      this.loading = true
      axios.ajaxGet('get',Api.api.dataExport.getDataExportDetails, this.dataExportDetailsParams).then(res=>{
        const { StatusCode, Reports, TotalCount } =  Object(res.data)
        if (StatusCode === 200) {
          this.list = Reports || []
          this.total = TotalCount || 0
        }
      }).finally(() => {
        this.loading = false
      })
      
    },
    // 表格分页参数改变
    currentChange(val) {
      this.dataExportDetailsParams.pageIndex = val
      this.getDetails()
      document.body.scrollTop = document.documentElement.scrollTop = 0
    },
    // 查看详情
    handleDetails(row) {
      let arg = arguments[1];
			this.qcresultsList.Name = row.Name
      if (arg) {
        this.setqcresultsShow(false)
        this.qcresultsList.expertUserId = row.ExpertUserGuids[0]
        this.qcresultsList.ReportGuid = row.ReportGuid
        this.qcresultsList.SamplingTaskGuid = row.SamplingTaskGuid
      } else {
        this.setqcresultsShow(true);
        this.qcresultsList.expertUserId = row.ExpertUserId
        this.qcresultsList.ReportGuid = this.datas.ReportGuid
        this.qcresultsList.SamplingTaskGuid = this.datas.SamplingTaskGuid
      }
      this.setDetailsParameter({
        reportGuid: this.qcresultsList.ReportGuid,
        samplingTaskGuid: this.qcresultsList.SamplingTaskGuid,
        ExpertUserGuid: this.qcresultsList.expertUserId
      })
      this.GetQCResultsByTask({
        samplingtaskguid: this.qcresultsList.SamplingTaskGuid,
        reportGuid: this.qcresultsList.ReportGuid
      })
      this.$router.push("/home/doctor/scoring")
      document.body.scrollTop = document.documentElement.scrollTop = 0
    }
  }
}
</script>

<style lang="scss" scoped>
.compentTable {
  .info-card {
    display: flex;
    align-items: center;
    height: 30px;
    line-height: 30px;
    padding-bottom: 20px;
    .date {
      font-size: 16px;
      font-weight: 500;
    }
    .line {
      width: 1px;
      height: 14px;
      margin: 0 18px;
    }
    .title {
      font-size: 14px;
      font-weight: 300;
    }
  }
}
</style>
  